import React, { Component } from "react";
import { Button, Form, FormGroup, Input, Label } from "reactstrap";
import authService from "../../services/auth";
import coreService from '../../services/core';

import {
    withRouter
  } from "react-router-dom"

import "./Login.css";
class Login extends Component {
    constructor(props) {
        super(props);

        this.state = {
            email: "",
            password: "",
            userTypeId: "1",
            error: null,
        };
    }

    validateForm() {
        return this.state.email.length > 0
            && this.state.password.length > 0
            && (this.state.userTypeId === "1" || this.state.userTypeId === "2" || this.state.userTypeId === "3");
    }

    handleChange = event => {
        this.setState({
            [ event.target.id ]: event.target.value
        });
    }

    handleSubmit = async (event) => {
        event.stopPropagation();
        event.preventDefault();
        try {
            this.setState({ error: null });
            const userInfo = await this.login(); // eslint-disable-line
            const userType = coreService.userTypes[userInfo.userTypeId.toString()].typeString;
            this.props.history.push( `/${ userType }/home` );
        } catch ( error ) {
            this.setState({ error: error.toString() });
        }
    }

    login = async () => {
        await authService.login(this.state.email, this.state.password, this.state.userTypeId);
        return authService.getUserFromToken();
    }
    

    render () {
        return (
            <div className="Login">
                <Form onSubmit={ this.handleSubmit }>
                    <FormGroup>
                        <Label>Email</Label>
                        <Input id="email"
                            autoFocus
                            type="email"
                            value={ this.state.email }
                            onChange={ this.handleChange }
                        />
                    </FormGroup>
                    <FormGroup>
                        <Label>Password</Label>
                        <Input id="password"
                            value={ this.state.password }
                            onChange={ this.handleChange }
                            type="password"
                        />
                    </FormGroup>
                    <FormGroup>
                        <Label>Login As</Label>
                        <Input
                            id="userTypeId"
                            type="select"
                            value={ this.state.userTypeId }
                            onChange={ this.handleChange }
                        >
                            <option value="1">Mentor</option>
                            <option value="2">Mentee</option>
                            <option value="3">Admin</option>
                        </Input>
                    </FormGroup>
                    <Button
                        block
                        disabled={ !this.validateForm() }
                        type="submit"
                    >
                        Login
                    </Button>
                    { this.state.error &&
                        <div className="alert alert-danger">{this.state.error}</div>
                    }
                </Form>
                <br/>

                <a href="/password/email" className="resetLink">Password Trouble?</a>
            </div>
        );
    }
}

export default withRouter(Login);